var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSinister5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6286 46.3261L21.9492 36.0474L26.5541 3.64893L44.3157 13.9276C44.6446 14.0921 44.8091 14.5032 44.7269 14.8322L44.6446 15.3255L45.9603 17.0524C46.207 17.3813 46.2892 17.8747 46.2892 18.2858L45.5491 23.5485C45.4669 24.0419 45.0558 24.3708 44.5624 24.3708H43.4112L40.3687 45.915C40.3687 46.3261 39.9575 46.4906 39.6286 46.3261Z",
    fill: "#FFCA61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5428 34.6495L21.949 36.0474L26.5539 3.64888L7.88773 2.25098C7.55881 2.25098 7.2299 2.49767 7.14767 2.82658L6.16091 9.65165L5.17415 10.3095C4.84523 10.5562 4.59854 10.8851 4.59854 11.2962L1.47381 33.416C1.39158 33.9916 1.88496 34.6495 2.5428 34.6495Z",
    fill: "#FAFBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9706 42.6257L25.0738 34.5672C24.6626 34.3205 24.4159 33.8271 24.4982 33.3337L28.1985 7.26691C28.2807 6.77353 28.7741 6.52685 29.1853 6.77354L43.0821 14.832C43.4932 15.0787 43.7399 15.5721 43.6577 16.0655L39.9574 42.1323C39.9574 42.6257 39.3818 42.8724 38.9706 42.6257Z",
    fill: "#545D94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3946 43.1188L24.4156 35.0603C24.0044 34.8136 23.7577 34.3203 23.84 33.8269L27.5403 7.76008C27.6225 7.2667 28.1159 7.02001 28.5271 7.2667L42.4239 15.3252C42.835 15.5719 43.0817 16.0653 42.9995 16.5587L39.3814 42.6255C39.2992 43.1188 38.8058 43.3655 38.3946 43.1188Z",
    fill: "#8C95CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2436 43.5303L23.5113 35.5541C23.1001 35.3074 22.8534 34.814 22.9357 34.3206L25.8137 13.7632L41.4374 22.7262L38.5593 42.8725C38.4771 43.5303 37.8192 43.8592 37.2436 43.5303Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.26 16.9703C42.3422 16.4769 42.0955 15.9836 41.6844 15.7369L27.8698 7.84281C27.3764 7.59612 26.8008 7.84281 26.7186 8.41842L25.9785 13.8456L41.4377 22.7264L42.26 16.9703Z",
    fill: "#FF858D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4754 14.5033L32.6398 13.681L28.1994 11.1318L28.1172 11.9541",
    fill: "#FF1C44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3497 19.7659C29.2675 20.2593 29.5142 20.6704 29.9254 20.9171L35.8459 24.2886C36.2571 24.5352 36.7504 24.2886 36.7504 23.8774C36.8326 23.384 36.586 22.9729 36.1748 22.7262L30.2543 19.3548C29.9254 19.1081 29.432 19.3548 29.3497 19.7659Z",
    fill: "#141938"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0334 22.562L27.9512 23.3843L37.2431 28.8115L37.3253 27.9069L28.0334 22.562Z",
    fill: "#C8C8FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7875 24.2886L27.623 25.1109L36.915 30.4558L37.0795 29.6335L27.7875 24.2886Z",
    fill: "#C8C8FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8012 33.7451L26.6367 34.5674L31.3238 37.281L31.4883 36.4587L26.8012 33.7451Z",
    fill: "#C8C8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSinister5);
export default __webpack_public_path__ + "static/media/ic_sinister_5.a93a128396de7c9a3bbe8635f12a5630.svg";
export { ForwardRef as ReactComponent };